export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  const lockScroll = () => {
    document.body.style.overflowY = 'hidden'
    document.documentElement.style.overflowY = 'hidden'
  }

  const unlockScroll = () => {
    document.body.style.overflowY = ''
    document.documentElement.style.overflowY = ''
  }

  requestAnimationFrame(() => {
    lockScroll()
    setTimeout(() => {
      // unlockScroll()
    }, 500)
  })
})